import { getOptionsFromParams } from 'helpers/utils/dropdownUtils';
import translation from 'locales/translation';
import { ToastTypes } from 'plataforma-fundacao-componentes';
import { Dispatch } from 'react';
import {
  getPresence,
  getPresenceAgencia,
  getPresenceNucleo,
} from 'services/assessor';

export const COMPUTE_VOTES_SET_FILTER = 'COMPUTE_VOTES_SET_FILTER';
export const COMPUTE_VOTES_AGENCIA_LOADING = 'COMPUTE_VOTES_AGENCIA_LOADING';
export const COMPUTE_VOTES_AGENCIA_VALUES = 'COMPUTE_VOTES_AGENCIA_VALUES';
export const COMPUTE_VOTES_NUCLEOS_LOADING = 'COMPUTE_VOTES_NUCLEOS_LOADING';
export const COMPUTE_VOTES_NUCLEOS_VALUES = 'COMPUTE_VOTES_NUCLEOS_VALUES';
export const COMPUTE_VOTES_LIST = 'COMPUTE_VOTES_LIST';
export const COMPUTE_VOTES_LIST_LOADING = 'COMPUTE_VOTES_LIST_LOADING';

export const loadPresenceList = (
  showToast: any,
  state: any,
  dispatch: Dispatch<any>
) => {
  dispatch({ type: COMPUTE_VOTES_LIST_LOADING, payload: true });

  return getPresence({
    idPauta: state.filter.idPauta,
    agencia: state.filter.agencia,
    nucleo: state.filter.nucleo,
  })
    .then(({ data }) => {
      dispatch({
        type: COMPUTE_VOTES_LIST,
        payload: data,
      });
    })
    .catch(() => {
      showToast({
        pauseOnFocusLoss: true,
        theme: ToastTypes.Error,
        showStatusBar: true,
        timeout: 4000,
        label: translation.ComputeVotes.errLoadPauta,
      });
    })
    .finally(() => {
      dispatch({ type: COMPUTE_VOTES_LIST_LOADING, payload: false });
    });
};

export const loadPresenceAgency = (
  dispatch: Dispatch<any>,
  state: any,
  showToast: any
) => {
  dispatch({ type: COMPUTE_VOTES_AGENCIA_LOADING, payload: true });

  return getPresenceAgencia({
    idPauta: state.filter.idPauta,
  })
    .then(({ data }) => {
      dispatch({
        type: COMPUTE_VOTES_AGENCIA_VALUES,
        payload: getOptionsFromParams(
          data.filter((ag: any) => ag),
          'agencia',
          (ag: any) => ag.agencia
        ),
      });
    })
    .catch(() => {
      showToast({
        pauseOnFocusLoss: true,
        theme: ToastTypes.Error,
        showStatusBar: true,
        timeout: 4000,
        label: translation.ComputeVotes.errLoadAgn,
      });
    })
    .finally(() => {
      dispatch({ type: COMPUTE_VOTES_AGENCIA_LOADING, payload: false });
    });
};

export const loadPresenceNucleo = (
  showToast: any,
  state: any,
  dispatch: Dispatch<any>
) => {
  dispatch({ type: COMPUTE_VOTES_NUCLEOS_LOADING, payload: true });

  return getPresenceNucleo({
    agencia: state.filter.agencia,
    idPauta: state.filter.idPauta,
  })
    .then(({ data }) => {
      dispatch({
        type: COMPUTE_VOTES_NUCLEOS_VALUES,
        payload: getOptionsFromParams(
          data.filter((nuc: any) => nuc.nucleo),
          'nucleo',
          (ag: any) => ag.nucleo
        ),
      });
    })
    .catch(() => {
      showToast({
        pauseOnFocusLoss: true,
        theme: ToastTypes.Error,
        showStatusBar: true,
        timeout: 4000,
        label: translation.ComputeVotes.errLoadNuc,
      });
    })
    .finally(() => {
      dispatch({ type: COMPUTE_VOTES_NUCLEOS_LOADING, payload: false });
    });
};
